import { ThumbsDownOutline, ThumbsUpOutline } from '@lyearn/icons';

import { EmojiEnum } from '../feedback/components/MoodEmojiList/consts';

export interface AIFeedbackReactionType {
  id: EmojiEnum;
  Icon: typeof ThumbsUpOutline;
  showPopover: boolean;
  labelKey: string;
  ariaLabelKey: string;
}

export const FEEDBACK_REACTIONS: Record<
  Exclude<EmojiEnum, EmojiEnum.Ok>,
  AIFeedbackReactionType
> = {
  [EmojiEnum.Happy]: {
    id: EmojiEnum.Happy,
    Icon: ThumbsUpOutline,
    showPopover: false,
    labelKey: 'Common:AIFeedback.Like',
    ariaLabelKey: 'Common:AIFeedback.ThumbsUp',
  },
  [EmojiEnum.Sad]: {
    id: EmojiEnum.Sad,
    Icon: ThumbsDownOutline,
    showPopover: true,
    labelKey: 'Common:AIFeedback.Dislike',
    ariaLabelKey: 'Common:AIFeedback.ThumbsDown',
  },
};
